import React, { useEffect, useState } from "react";
import "./../../assets/sass/_login.scss";
import "./../FontAwesome/FontAwesome";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { loginAuth } from "../../features/setting/userSlice";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import loginvideo from "./../../assets/img/MISR-Login-Page Simulation.mp4";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";

function Login({ short_title, sponsor_logo, mainHeading,subHeading,logo }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  let navigate = useNavigate();
  const dispatch = useDispatch();

  // password show/hide
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (e) => {
    setIsLoading(true);
    e.preventDefault();
    const user = { email, password };

    dispatch(loginAuth(user))
      .unwrap()
      .then(() => {
        setIsLoading(false);
        navigate("/dashboard");
      })
      .catch((error) => {
        setIsLoading(false);
        setLoginError(error?.error_message);
      });
  };

  useEffect(() => {
    localStorage.removeItem("loginError");
    localStorage.removeItem("user");
    localStorage.removeItem("pageId");
    localStorage.removeItem("subPageId");
    localStorage.removeItem("search");
    localStorage.removeItem("studyId");
    localStorage.removeItem("studyTitle");
    localStorage.removeItem("invitation");
  }, []);

  return (
    <div className="login--content">
      {/* <div className="left--side   d-flex justyfy-content:center;">
        <div className="video-border-lef"></div>
        <div className="login-animation-vid">
          <video
            autoPlay
            muted
            loop
            className="img-fluid2 video"
            style={{ boxShadow: "2px 2px 10px #00000029" }}
          >
            <source src={loginvideo} type="video/mp4" />
          </video>
        </div>
        <div className="video-border-righ--1"></div>
        <div className="video-border-righ--2"></div>
      </div> */}
      <div className="right--side">
      <div>
      <div style={{height:"50%"}} className='main--logo'>
        <img src={logo} className="img-fluid" alt='' />
      </div>
      <div 
      // style={{height: "50%"}}
       className='main--text'>
        <h1 className='main--heading'> {mainHeading}</h1>
        <div className='sub--heading'> {subHeading}</div>
      </div>
    </div>
        <div style={{ height: "100%" }} className="login--box">
          <h1 className="login--box--heading">LOGIN</h1>
          <div className="welcome">Welcome to {short_title}</div>

          <form className="login-sigUp-font" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">
                {<FontAwesomeIcon icon="user" style={{ color: "#044f75" }} />}
                Email <sup className="text-danger">*</sup>
              </label>
              {/* <br /> */}
              <input
                type="email"
                value={email}
                className="form-control custom--form--control"
                placeholder="Enter your username"
                // onChange={(e) => setEmail(e.target.value)}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setLoginError("");
                }}
                required
              />
            </div>
            <div className="form-group mt-3">
              <label htmlFor="password ">
                {<FontAwesomeIcon icon="key" style={{ color: "#044f75" }} />}
                Password <sup className="text-danger">*</sup>
              </label>

              {/* <br /> */}
              <div className="d-flex align-item-center">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={password}
                  // onChange={(e) => setPassword(e.target.value)}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setLoginError("");
                  }}
                  autoComplete="current-password"
                  className="form-control custom--form--control"
                  placeholder="Password"
                  required
                />
                <div
                  className="password-icon-toggle "
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? (
                    <IoEyeOutline size={25} />
                  ) : (
                    <IoEyeOffOutline size={25} />
                  )}
                </div>
              </div>
            </div>
            {/* {loginError ? (
                <p className='alert-danger p-2 rounded text-center text-danger'>
                  {loginError}
                </p>
              ) : (
                ""
              )} */}
            {loginError ? (
              <p className="alert-danger ms-1 mt-1 rounded text-danger">
                {loginError}
              </p>
            ) : (
              ""
            )}

            {/* <div class="form-group text-end">
                <Link to="/forgetPassword" className="forget--password">
                  Forget password?
                </Link>
              </div> */}

            <div className="form-group text-center mt-3">
              <span className="position-relative">
                <input
                  type="submit"
                  value={isLoading ? "LOGGING IN..." : "LOGIN"}
                  className={
                    isLoading
                      ? "submit--btn submit--btn-disabled"
                      : "submit--btn"
                  }
                  disabled={isLoading}
                />
                {/* <FontAwesomeIcon icon="fa-solid fa-arrow-right" /> */}
              </span>
            </div>
            {/* <div
              class="form-group text-start mt-3"
              style={{ marginTop: "-28px" }}
            >
              <div className="d-flex create-acount-link">
                <div className="">Don't have an account?</div>

                <span className="ms-2">
                  <Link to="/signup" className="Sign--up">
                    Create Account
                  </Link>
                </span>
              </div>
            </div> */}
            <div
              className="d-flex justify-content-between mt-3 "
              // style={{ marginTop: "-28px" }}
            >
              <div className="d-flex create-acount-link">
                <div className="">Don't have an account?</div>
                <span className="ms-2">
                  <Link to="/signup" className="Sign--up">
                    Create Account
                  </Link>
                </span>
              </div>
              <div className="box--logo ">
                <img src={sponsor_logo} alt="" />
              </div>
            </div>
          </form>
          {/* <div className="box--logo text-center mt-3">
            <img src={sponsor_logo} alt="" />
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Login;
